import { Grid, IconButton, Stack } from '@mui/material';
// import { useFetchTrainingFeedback } from "@tms/services/tms-feedback";
// import EditIcon from "@mui/icons-material/Edit";
import { useState } from 'react';
import TrainingFeedbackModal from './TrainingFeedbackModal';
import { Button } from '@mui/material';
import { useFetchTrainingFeedback } from 'redux/reducers/user/dashboard/tms-feedback';
import { BiEdit, BiLoader } from 'react-icons/bi';
// import CircularLoader from "@tms/components/Loader/CircularProgress";

const TrainingFeedback = () => {
  const { data: trainingFeedback, isLoading } = useFetchTrainingFeedback();

  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);

  const [routineId, setRoutineId] = useState<string>('');

  const [item, setItem] = useState();

  const handleOpenFeedbackModal = (item: any) => {
    setItem(item);
    setOpenFeedbackModal(true);
  };

  const handleCloseFeedbackModal = () => {
    setOpenFeedbackModal(false);
  };

  return (
    <>
      {openFeedbackModal && (
        <TrainingFeedbackModal
          openFeedbackModal={openFeedbackModal}
          handleCloseFeedbackModal={handleCloseFeedbackModal}
          routineId={routineId}
          item={item}
        />
      )}
      <div>
        {trainingFeedback ? (
          trainingFeedback.map((item, index) => {
            if(!item.feedback_enabled) return null; 
            return (
              <>
                <Stack
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  sx={{
                    backgroundColor: `${index % 2 === 0 ? '#edeff0' : 'white'}`,
                    p: 1.5
                  }}>
                  <Grid item xs={6}>
                    {item.training_data[0].training_name}
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                    {item?.feedback_submit_status == false ? (
                      <IconButton color="primary" aria-label="add to shopping cart">
                        <BiEdit
                          onClick={() => {
                            handleOpenFeedbackModal(item);
                            setRoutineId(item.routine.toString());
                          }}
                        />
                      </IconButton>
                    ) : (
                      <Button
                        style={{
                          background: '#006ECB',
                          color: '#fff',
                          fontSize: '12px',
                          height: '25px'
                        }}>
                        Already Submitted
                      </Button>
                    )}
                  </Grid>
                </Stack>
              </>
            );
          })
        ) : isLoading ? (
          <BiLoader />
        ) : (
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <h4>No Trainings</h4>
          </Stack>
        )}
      </div>
    </>
  );
};

export default TrainingFeedback;
